import React from "react";
import { Box, Button, Card, Heading } from "rebass";
import { Field, FieldProps, Form } from "formik";

import { FormTypes } from "./formSettings";
import { SubmitButton } from "../components/SubmitButton";

import { Scrollbar } from "../../components/Scrollbar";
import { StyledTextarea } from "../../components/styled/Textarea";

export const FormComponent: React.FC<FormTypes> = (
  {
    handleReset,
    isSubmitting,
    isValid,
    dirty
  }
) => (
  <Form style={{ height: "100%" }}>
    <Box
      height="100%"
      css="min-height: 10rem; min-width: 30rem;"
    >
      <Heading as="h4" m="17px">Add Folder</Heading>

      <Card
        m="17px"
        px="18px"
        py="12px"
        borderRadius="5px"
        fontSize="18px"
        color="zodiac"
        backgroundColor="#fff"
        boxShadow="0 3px 29px 0 rgba(0,0,0,0.23)"
        css="overflow: hidden;"
      >
        <Scrollbar style={{ height: "42px" }}>
          <Field
            name="title"
            render={({ field }: FieldProps) => (
              <StyledTextarea
                {...field}
                placeholder="new name"
                disabled={isSubmitting}
                rows={2}
              />
            )}
          />
        </Scrollbar>
      </Card>

      <Card
        p="18px"
        fontSize="14px"
        bg="#fff"
        borderTop="2px solid"
        borderTopColor="sp-gray"
        css="display: flex; justify-content: space-between;"
      >
        <Button
          type="button"
          px="10px"
          py="5px"
          border="1px solid"
          borderColor="hoki"
          borderRadius="5px"
          color="hoki"
          bg="transparent"
          fontWeight="bold"
          css="text-transform: uppercase;"
          onClick={handleReset}
          disabled={isSubmitting || !dirty}
        >
          reset
        </Button>

        <SubmitButton
          width="unset"
          px="10px"
          py="5px"
          disabled={isSubmitting || !isValid}
        >
          add
        </SubmitButton>
      </Card>
    </Box>
  </Form>
);
